export default class DataFeed {
  constructor(data) {
    this.data = data;
    this.responded = false;
  }

  onReady(callback) {
    setTimeout(() => callback({
      supports_search: true,
      supports_group_request: false,
      supports_marks: true,
      supports_timescale_marks: true,
      supports_time: true,
      supported_resolutions: [this.data["widget"]["interval"]],
    }), 0);
  }

  searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
    const symbols = this.data["symbols"];
    setTimeout(() => onResultReadyCallback(symbols), 0);
  }

  resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
    for ( const symbolInfo of this.data["symbols"] ) {
      if ( symbolInfo["symbol"] === symbolName ) {
        setTimeout(() => onSymbolResolvedCallback(symbolInfo), 0);
        return;
      }
    }
    setTimeout(() => onResolveErrorCallback("Symbol not found"), 0);
  }

  getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
    if ( this.responded ) {
      onHistoryCallback([], { noData: true });
      return;
    }
    this.responded = true;
    const bars = symbolInfo["bars"];
    onHistoryCallback(bars, { noData: false });
  }

  getMarks(symbolInfo, from, to, onDataCallback, resolution) {
    onDataCallback(this.data["marks"] || []);
  }

  getTimescaleMarks(symbolInfo, from, to, onDataCallback, resolution) {
    onDataCallback(this.data["timescale_marks"] || []);
  }

  subscribeBars(symbolInfo, resolution, onRealtimeUpdate, subscriberUID, onResetCache) {
  }

  unsubscribeBars(subscriberUID) {
  }
}
